import {Model} from "@tailflow/laravel-orion/lib/model";

export default class Feature extends Model<{}> {
    public $resource(): string {
        return "features";
    }

    public $getKeyName() : string {
        return 'id';
    }
}
